import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { CatchBoundary, createRouter, ErrorRouteComponent, RouterProvider } from '@tanstack/react-router';
import mixpanel from 'mixpanel-browser';
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as config from '../package.json';
import Error from './components/ErrorPage/ErrorPage';
import './styles/index.css';


// Import the generated route tree
import { Provider } from 'react-redux';
import store from 'store';
import { applyDefaultTheme } from 'styles/themes/utils';
import { trackPageView } from 'utils/analytics';
import { routeTree } from './routeTree.gen';
import { NotFoundComponent } from 'app/_authenticated/not-found/components/NotFound';

// Create a new router instance
const router = createRouter({
  routeTree,
  // Preload routes when the user hovers over links
  defaultPreload: 'intent',
  defaultNotFoundComponent: NotFoundComponent,
  defaultErrorComponent: (error: any) => {
    const errorMessage = error?.error?.message;
    Bugsnag.notify(errorMessage)
    return <Error />
  },
  
});

router.history.subscribe(() => {
  trackPageView(router.history.location.pathname);
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

Bugsnag.start({
  apiKey: import.meta.env.VITE_BUG_SNAG_API_KEY as string,
  plugins: [new BugsnagPluginReact()],
  releaseStage: import.meta.env.NODE_ENV || 'development',
  appVersion: config.version,
});

mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN as string, {
  debug: import.meta.env.VITE_ENV === 'development',
  ignore_dnt: true,
});

applyDefaultTheme();


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>  
  </React.StrictMode>,
);
